import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GraphData } from '@classes/graph/graph';
import { RecordsCoudPouce } from '@classes/records/record';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-chart-sales-fc',
  templateUrl: './chart-sales-fc.component.html',
  styleUrls: ['./chart-sales-fc.component.scss']
})
export class ChartSalesFcComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() numberDayOfMonth: number;
  @Input() year: number;
  // typeTime: string;
  // @Input() set typeTime(value: string) { this.typeTime = value; }

  public barChartOptions = {
    responsive: true,

    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      }
    },
    scales: {
      xAxes: [{
        stacked: true // change to false

      }],
      yAxes: [{
        stacked: true

      }]
    }
  };

  arrayMonth = ['janv', 'fév', 'mars', 'avril', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];

  public barChartLabels = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  // data: RecordsCoudPouce[] = [];
  dataLabel: GraphData = {
    label: 'Articles cintrés',
    data: []
  };

  public barChartData = [
    {
      label: 'Homme',
      stack: 'one',
      backgroundColor: '#7fcff7',
      hoverBackgroundColor: '#12a7ef',
      data: []
    },
    {
      label: 'Femme',
      stack: 'one',
      backgroundColor: '#ff9ebd',
      hoverBackgroundColor: '#ff4a86',
      data: []
    },
    {
      label: 'Enfant',
      stack: 'two',
      backgroundColor: ' #ffe7a2',
      hoverBackgroundColor: '#ffd153',
      data: []
    },
    {
      label: 'Chaussure/Accesoire',
      stack: 'two',
      backgroundColor: '#aaffa2',
      hoverBackgroundColor: '#89ff53',
      data: []
    }
  ];
  typeTime: string;
  data: RecordsCoudPouce[];

  selectFC: string;

  constructor(
    private recordsService: RecordsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();

  }

  private initGraph(): void {
    // this.barChartData = [];
    this.barChartLabels = [];
    this.barChartData[0].data = [];
    this.barChartData[1].data = [];
    this.barChartData[2].data = [];
    this.barChartData[3].data = [];


    switch (this.typeTime) {
      case 'year':
        this.barChartLabels = this.arrayMonth;
        for (let i = 0; i < this.arrayMonth.length; i++) {
          this.barChartData[0].data.push(0);
          this.barChartData[1].data.push(0);
          this.barChartData[2].data.push(0);
          this.barChartData[3].data.push(0);

        }
        break;
      case 'month':
        for (let i = 1; i <= this.numberDayOfMonth; i++) {
          i < 10 ?
            this.barChartLabels.push('0' + i) :
            this.barChartLabels.push(i.toString());
          this.barChartData[0].data.push(0);
          this.barChartData[1].data.push(0);
          this.barChartData[2].data.push(0);
          this.barChartData[3].data.push(0);

        }
        break;
      default:
        break;
    }

  }

  private initValueGraph(): void {
    const dataFilter = [];
    this.data?.forEach(item => {
      if (item.step.description === 'Fripeschic' && item.type === 'Input' && item.category.name === this.selectFC) {
        dataFilter.push(item);
      }
    });

    switch (this.typeTime) {
      case 'month':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          dataFilter?.forEach(data => {
            const day = data.createdOn.split('T')[0].split('-')[2];

            switch (data.type) {
              case 'Input':
                day === item && (data.category.subCategory?.name === 'Homme' || data.category.subCategory?.subCategory?.name === 'Homme' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Homme') ?
                  this.barChartData[0].data[index] += data.value :
                  null;
                day === item && (data.category.subCategory?.name === 'Femme' || data.category.subCategory?.subCategory?.name === 'Femme' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Femme') ?
                  this.barChartData[1].data[index] += data.value :
                  null;
                day === item && (data.category.subCategory?.name === 'Enfant' || data.category.subCategory?.subCategory?.name === 'Enfant' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Enfant') ?
                  this.barChartData[2].data[index] += data.value :
                  null;
                day === item && (data.category.subCategory?.name === 'Chaussures/Accessoires' || data.category.subCategory?.subCategory?.name === 'Chaussures/Accessoires' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Chaussures/Accessoires') ?
                  this.barChartData[3].data[index] += data.value :
                  null;
                break;


              default:
                break;
            }
          });
        });
        break;
      case 'year':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          dataFilter?.forEach(data => {
            const month = new Date(data.createdOn).getMonth();
            const year = new Date(data.createdOn).getFullYear();
            switch (data.type) {
              case 'Input':
                index === month && this.year === year && (data.category.subCategory?.name === 'Homme' || data.category.subCategory?.subCategory?.name === 'Homme' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Homme') ?
                  this.barChartData[0].data[index] += data.value :
                  null;
                index === month && this.year === year && (data.category.subCategory?.name === 'Femme' || data.category.subCategory?.subCategory?.name === 'Femme' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Femme') ?
                  this.barChartData[1].data[index] += data.value :
                  null;
                index === month && this.year === year && (data.category.subCategory?.name === 'Enfant' || data.category.subCategory?.subCategory?.name === 'Enfant' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Enfant') ?
                  this.barChartData[2].data[index] += data.value :
                  null;
                index === month && this.year === year && (data.category.subCategory?.name === 'Chaussures/Accessoires' || data.category.subCategory?.subCategory?.name === 'Chaussures/Accessoires' || data.category.subCategory?.subCategory?.subCategory?.subCategory?.name === 'Chaussures/Accessoires') ?
                  this.barChartData[3].data[index] += data.value :
                  null;
                break;

                break;
            }
          });
        });

        break;
      default:
        break;
    }
  }

  private initSub(): void {

    this.subscription
      .add(
        this.recordsService.eventsListSubject.asObservable().subscribe(event => {
          this.dataService.dataGraph$.next(event?.body);
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.typeTime$.asObservable().subscribe(typeTime => {
          this.typeTime = typeTime;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.dataGraph$.asObservable().subscribe(dataGraph => {
          this.data = dataGraph;
          this.cdr.detectChanges();
          this.initGraph();
          this.initValueGraph();
        })
      )
      .add(
        this.dataService.selectFC$.subscribe({
          next: selectFC => {
            this.selectFC = selectFC;
            this.initGraph();
            this.initValueGraph();
            this.cdr.detectChanges();
          }
        })
      );
  }

}
